import { useEffect, useState } from "react";
import scene1 from "@/assets/hero-scene-1.jpg";
import scene2 from "@/assets/hero-scene-2.jpg";
import scene3 from "@/assets/hero-scene-3.jpg";
import scene4 from "@/assets/hero-scene-4.jpg";
import scene5 from "@/assets/hero-scene-5.jpg";
import scene6 from "@/assets/hero-scene-6.jpg";

const SCENES = [scene1, scene2, scene3, scene4, scene5, scene6];
const SCENE_DURATION = 5000; // chaque scène passe une seule fois, 5s avant la suivante

const HeroVideoBackground = () => {
  const [index, setIndex] = useState(0);
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    if (reduced) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % SCENES.length);
    }, SCENE_DURATION);
    return () => clearInterval(id);
  }, [reduced]);

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      {/* Slideshow vidéo (chaque scène une seule fois, boucle continue) */}
      {SCENES.map((src, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-[1500ms] ease-in-out will-change-[opacity,transform]"
          style={{
            opacity: i === index ? 1 : 0,
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transform: i === index ? "scale(1.06)" : "scale(1)",
            transitionProperty: "opacity, transform",
            transitionDuration: "1500ms, 6000ms",
          }}
        />
      ))}

      {/* Overlay dégradé doux violet/rose/bleu pour lisibilité */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/55 via-secondary/40 to-accent/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/30 to-background/40" />

      {/* Préchargement discret des scènes suivantes */}
      <div className="hidden">
        {SCENES.map((src, i) => (
          <img key={i} src={src} alt="" width={1} height={1} />
        ))}
      </div>
    </div>
  );
};

export default HeroVideoBackground;
